(function ($) {

    //************************************
    // Footer
    //************************************

    if ($('body').hasClass('error404')) {

        $(window).on('load resize scroll', function () {
            var f = $('footer');
            if (f.offset().top + f.height() < $(window).height()) {
                $('footer').addClass('sticky');
            }
        });

    }

})(jQuery);


// WEBPACK FOOTER //
// ./src/js/custom/sticky-footer.es6